import type { LmtErrorResponse } from "@albertine/types/openapi";
import { toApiErrorMessage } from "../../common/utils/apiError.util";
import { EventEmitter } from "../../EventEmitter";

type MemberProfileActionResponseListener = {
    onSuccess: () => void;
    onError: (error: LmtErrorResponse) => void;
};
export function toApiListenerWithToastMessages(
    onSuccess: () => void,
    onError: (error: LmtErrorResponse) => void = () => {},
): MemberProfileActionResponseListener {
    return {
        onSuccess: () => {
            EventEmitter.emit({
                name: "showToastMessage",
                params: {
                    type: "info",
                    message: "Member information updated successfully",
                },
            });
            onSuccess();
        },
        onError: (error) => {
            EventEmitter.emit({
                name: "showToastMessage",
                params: {
                    type: "error",
                    message: `Member information update failed: ${toApiErrorMessage(error, "Please try again.")}`,
                },
            });
            onError(error);
        },
    };
}
